import React,{useEffect} from "react";
import classes from "./InfoForm.module.css";

import gsap from "gsap";
import Space from "../../../../UI/Space/Space"

const InfoForm = (props) => {
  let price = 1500

  if(props.selected.letter === "A" || props.selected.letter === "B" || props.selected.letter === "C"){
    price = 3000;
  }

  useEffect(()=>{
    console.log(props.selected)
    const rows = document.getElementsByClassName(classes.row)
    // console.log(rows)
    gsap.from(rows,{
        delay:0.5,
        duration:0.5,
        opacity: 0,
        xPercent:100,
        stagger:0.1,
    })

},[])
  return (
    <div className={classes.container}>
      {/* <Space height={100}/> */}
      <span className={classes.row}>
      <div className={classes.label}>Seat:</div><div className={classes.seat}> {props.selected.letter} {props.selected.number}</div>
      </span>
      <span className={classes.row}>
      <div className={classes.label}>Price:</div><div className={classes.seat}>{price}$</div>
      </span>
      <span className={classes.row}>
        <div className={classes.label}>Name:</div>
        <input className={classes.textField} />
      </span>
      <span className={classes.row}>
        <div className={classes.label}>Phone Number:</div>
        <input type="tel" className={classes.textField} />
      </span>

    </div>
  );
};
export default InfoForm;
